export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer>
            © {year} Kentucky Sato.
            <br></br>
            All Rights Reserved.
        </footer>
    )
}